import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { LodgingMediaAsset } from "@b2bportal/lodging-api";
import { useImageGallery } from "@tenant/hotels";
import { Dialog, DialogContent } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./ImageGallery.module.scss";

export interface ImageGalleryComponentProps extends PlatformComponentProps {
  media: LodgingMediaAsset[];
  name?: string;
}

const COMPONENT_KEY = CoreHotelsComponent.ImageGallery;

export const ImageGallery = (props: ImageGalleryComponentProps) => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { className, children } = props;

  const { context, text } = useImageGallery(props);
  return (
    <div className={clsx(block, className)}>
      <div
        className={cn("showcase", {
          [context.imageColumns ?? ""]: context.imageColumns != null,
        })}
      >
        {context.showCaseImages.map((image, index) => (
          <button
            key={index}
            onClick={() => context.imageGalleryDialog.openDialog()}
            className={cn("showcase-image", [`${index}`])}
          >
            <img
              className={cn("image")}
              alt={text.getAltText(image)}
              src={image.url}
            />
          </button>
        ))}
        <button
          className={cn("image-button")}
          onClick={() => context.imageGalleryDialog.openDialog()}
        >
          {text.imageButton}
        </button>
      </div>
      <Dialog {...context.imageGalleryDialog.props}>
        <DialogContent fullScreen={true} title={text.dialogTitle}>
          <div className={cn("dialog-container")}>
            {context.images.map((image, index) => (
              <img
                key={index}
                className={cn("image")}
                alt={text.getAltText(image)}
                src={image.url}
              />
            ))}
          </div>
        </DialogContent>
      </Dialog>
      {children}
    </div>
  );
};
